import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content"]

  // 点击时执行闪烁效果
  flash() {
    if (!this.hasContentTarget) return

    // 1. 变为半透明 (变暗)
    this.contentTarget.style.transition = "opacity 0.1s ease-in-out"
    this.contentTarget.style.opacity = "0.3"

    // 2. 100ms 后恢复
    setTimeout(() => {
      this.contentTarget.style.opacity = "1"
    }, 100)
  }
}
